module.exports = __webpack_public_path__ + "bc41e114041f67b67246fd8f422c9600.png";